import React from "react"
import { CopyToClipboard } from "react-copy-to-clipboard"
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined"
import styled from "styled-components/macro"
import * as IconsGallery from "@iconsGallery"
import {
  CardContent as MuiCardContent,
  Typography as MuiTypography,
  Button,
  Grid,
  IconButton,
  Tooltip,
} from "@material-ui/core"
export const StyledMainWrapperCardView = styled(Grid)`
  min-width: 300px;
  max-width: 800px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 18px;
  margin: 10px;
  width: 100%;

  @media (min-width: 900px) and (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr) !important;
  }

  @media (min-width: 300px) and (max-width: 900px) {
    grid-template-columns: repeat(1, 1fr) !important;
    min-width: 300px !important;
  }
`
export const StyledItemWrapperCardView = styled(Grid)`
  width: 100%;
  min-height: 150px;
  height: fit-content;
  border-radius: 15px;
  border: 1px solid #e8dff2;
  padding: 10px;
  transition: all 400ms ease;

  &:hover {
    transform: scale(1.08);
    border: 3px solid #e8dff2;
  }

  .cls-header-kit-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 38px;
    position: relative;
  }

  .cls-header-kit-container-title {
    min-width: 100px;
    width: 70%;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    word-wrap: break-word;
    font-weight: bold;
  }
  .cls-header-kit-container-video-thumb {
    width: 100%;
    padding: 1px;
    margin-top: 10px;
    svg {
      width: 100%;
      height: fit-content;
    }
  }
`

const defaultData = [
  {
    title: "test",
    url: "test",
  },
  {
    title: "test2",
    url: "test2",
  },
  {
    title: "test3",
    url: "test3",
  },
  {
    title: "test4",
    url: "test4",
  },
  {
    title: "test5",
    url: "test5",
  },
  {
    title: "test6",
    url: "test6",
  },
  {
    title: "test7",
    url: "test7",
  },
  {
    title: "test8",
    url: "test8",
  },
]

const CopyBoard = (innerItem) => {
  const [getCopyText, setCopyText] = React.useState("")
  const [getCopyTextFlag, setCopyTextFlag] = React.useState(false)

  const handleCardClick = () => {
    if (innerItem?.url?.includes("verkada")) {
      window.open(innerItem?.url, "_blank")
    }
  }

  return (
    <StyledItemWrapperCardView style={{ cursor: "pointer" }}>
      <div className="cls-header-kit-container">
        <div className="cls-header-kit-container-title">
          {`${innerItem?.globalType} ${innerItem?.title}`}
        </div>

        <div
          style={{
            position: "absolute",
            right: 26,
            top: 9,
            opacity: getCopyTextFlag ? 1 : 0,
            transform: getCopyTextFlag ? "translateX(-3px)" : "translateX(0px)",
            transition: "all 250ms ease",
            color: "var(--primaryColor)",
            fontWeight: 600,
            backgroundColor: "white",
          }}
        >
          {"Copied!"}
        </div>
        <div style={{ display: "flex" }}>
          {innerItem?.url?.includes("verkada") ||
            (innerItem?.url?.includes?.(".mp4") && (
              <Tooltip title={"Open"}>
                <IconButton
                  style={{ padding: 0, marginRight: 10 }}
                  width="30"
                  height="30"
                  onClick={() => {
                    window.open(innerItem?.url, "_blank")
                  }}
                >
                  <IconsGallery.OpenIcon />
                </IconButton>
              </Tooltip>
            ))}
          <CopyToClipboard
            text={innerItem?.url}
            onCopy={() => {
              setCopyText("copied")
              setCopyTextFlag(true)
              setTimeout(() => {
                setCopyText("")
                setCopyTextFlag(false)
              }, 3000)
            }}
          >
            <Tooltip title={"Copy"}>
              <FileCopyOutlinedIcon
                style={{
                  fontSize: 20,
                  cursor: "pointer",
                  color: "rgba(166, 41, 145, 1)",
                }}
              ></FileCopyOutlinedIcon>
            </Tooltip>
          </CopyToClipboard>
        </div>
      </div>
      <div
        className="cls-header-kit-container-video-thumb"
        onClick={handleCardClick}
      >
        {innerItem?.url?.includes?.(".mp4") ? (
          <video style={{ width: "100%" }} controls>
            <source src={innerItem?.url} type="video/mp4" />
          </video>
        ) : (
          <IconsGallery.VideoThumb />
        )}
      </div>
    </StyledItemWrapperCardView>
  )
}
function MultipleCopyBoard(props) {
  const { globalType = "Verkada", list = defaultData || [] } = props || {}

  let lcList = list
  return (
    <StyledMainWrapperCardView>
      {lcList.length ? (
        lcList.map((itm) => {
          return <CopyBoard {...itm} globalType={globalType} />
        })
      ) : (
        <div>{`No Records Found`}</div>
      )}
    </StyledMainWrapperCardView>
  )
}

export { MultipleCopyBoard }
export default MultipleCopyBoard
